import { useEffect, useState } from "react"

const breakpoints = {
  lg: 1200,
  md: 992,
  sm: 768,
  xl: 1400,
  xs: 576,
}

const getBreakpoint = (width: number) => {
  if (width >= breakpoints.xl) return "xl"

  if (width >= breakpoints.lg) return "lg"

  if (width >= breakpoints.md) return "md"

  if (width >= breakpoints.sm) return "sm"

  return "xs"
}

export const useBreakpoint = () => {
  const [breakpoint, setBreakpoint] = useState(() =>
    getBreakpoint(window.innerWidth),
  )

  useEffect(() => {
    const handleResize = () => {
      setBreakpoint(getBreakpoint(window.innerWidth))
    }

    window.addEventListener("resize", handleResize)
    handleResize()
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  return {
    breakpoint,
    isLg: breakpoint === "lg",
    isMobile: breakpoint === "xs" || breakpoint === "sm",
    isTablet: breakpoint === "md",
    isXl: breakpoint === "xl",
    smallerThanLg:
      breakpoint === "md" || breakpoint === "sm" || breakpoint === "xs",
    smallerThanMd: breakpoint === "sm" || breakpoint === "xs",
    smallerThanXl: breakpoint !== "xl",
  }
}
